module.exports = __webpack_public_path__ + "static/media/light-ceiling.5dc06d02.svg";